import { createSelector } from 'reselect';

export interface StorePageState {
  loading: boolean;
  store: any;
  historyCollections: any[];
  storeId: any;
}

export const initialState: StorePageState = {
  loading: false,
  store: null,
  historyCollections: [],
  storeId: '',
};

const getStorePage = ({ storePage }: any): StorePageState => storePage;

export const storeSelectors = {
  getStore: createSelector(
    [getStorePage],
    ({ store }) => store,
  ),

  getLoading: createSelector(
    getStorePage,
    ({ loading }) => loading,
  ),

  getHistoryCollections: createSelector(
    getStorePage,
    ({ historyCollections }) => historyCollections,
  ),
};



// WEBPACK FOOTER //
// ./src/scenes/Store/services/selectors.ts